import React, { useState } from "react";
import { toast } from "sonner";
import { Image as ImageIcon } from "lucide-react";
import api, { formatError } from "../lib/api";
import { Button } from "./ui/button";

export function ShareImageButton({ url, filename, text, label = "Share as image", testId }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get(url, { responseType: "blob" });
      const file = new File([r.data], filename, { type: "image/png" });
      if (navigator.canShare?.({ files: [file] })) { await navigator.share({ files: [file], text }); return; }
      const href = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = href; a.download = filename; a.click(); URL.revokeObjectURL(href);
      toast.success("Image downloaded — attach it in WhatsApp");
    } catch (e) { if (e?.name !== "AbortError") toast.error(formatError(e.response?.data?.detail) || "Could not build the image"); }
    finally { setBusy(false); }
  };
  return <Button variant="outline" onClick={run} disabled={busy} className="gap-1 border-gold text-crimson" data-testid={testId}><ImageIcon size={14} /> {busy ? "Preparing…" : label}</Button>;
}
